import React, {Component} from "react"
import classNames from "classnames"
import ReactHeight from "react-height"

import {DealCategory} from "@irati/types"
import Tag from "@irati/ui/src/Tag"

import "./styles/Categories.css"

interface Props {
  data: DealCategory[],
  isShowingMore: boolean,
  handleCategoryClick: (category: DealCategory) => void,
  displayShowMoreText: boolean,
  shouldDisplayShowMoreText: () => void,
  selected: DealCategory
}

class Categories extends Component<Props> {
  onHeightReady = (height: number) => {
    const {displayShowMoreText, shouldDisplayShowMoreText} = this.props
    if (!displayShowMoreText && height > 60) {
      shouldDisplayShowMoreText()
    }
  }

  render() {
    const {data, isShowingMore, handleCategoryClick, displayShowMoreText, selected = false} = this.props

    const className = classNames({
      categoryTagsCategories_showMoreSelected: displayShowMoreText && isShowingMore,
      categoryTagsCategories_showMoreUnSelected: displayShowMoreText && !isShowingMore
    })

    return (
      <ReactHeight onHeightReady={this.onHeightReady}>
        <div className={className}>
          {data.map((category) => {
            // "all" tag will always have the "dealCount" prop.
            // If we request rewardCategories, we won't have dealCount, but we'll have rewardCount instead
            const count = category.dealCount || category.rewardCount
            return (
              <Tag
                name={category.name!}
                count={count}
                selected={selected === category}
                onClick={() => handleCategoryClick(category)}
                key={category.uuid} />
            )
          })}
        </div>
      </ReactHeight>
    )
  }
}

export default Categories
